import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, viewChild } from '@angular/core';
import { SystemMessage, SystemMessageService } from 'app/core/system-message/system-message-service';
import { NixieListVm } from 'app/shared/generated/Nixies/Models/NixieListVm';
import { NixieUploadListVm } from 'app/shared/generated/Nixies/Models/NixieUploadListVm';
import { DateRange } from 'app/shared/models/date-range';
import { SharedModule } from 'app/shared/shared.module';
import { ButtonFilterService } from 'app/shared/table/table-top/button-filter/button-filter.service';
import { TableComponent } from 'app/shared/table/table.component';
import { Subscription } from 'rxjs';

@Component({
	selector: 'pcg-nixie-list',
	imports: [SharedModule],
	templateUrl: './nixie-list.component.html',
	styleUrl: './nixie-list.component.scss',
})
export class NixieListComponent implements OnInit, OnDestroy {
	table = viewChild<TableComponent<NixieListVm>>('table');
	uploadsTable = viewChild<TableComponent<NixieUploadListVm>>('uploadsTable');
	columns = NixieListVm.ColumnDefs;
	uploadColumns = NixieUploadListVm.ColumnDefs;
	backfillRunning = false;

	filters = { dateRange: new DateRange() };
	initFilters = { dateRange: new DateRange() };

	// Full filtered-set sums for the totals row, sent back with each table load
	totals: { nystaRecords: number; nysbaRecords: number } = null;

	subscriptions = new Subscription();

	constructor(
		private ms: SystemMessageService,
		private httpClient: HttpClient,
		public btnFilterService: ButtonFilterService,
	) {}

	ngOnInit() {
		this.subscriptions.add(
			this.btnFilterService.resetFilterData.subscribe(() => this.resetFilters())
		);
	}

	resetFilters() {
		this.filters = Object.assign(this.filters, this.initFilters);
		this.uploadsTable()?.ajaxReload();
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	backfillDigitalNixie() {
		if (
			this.backfillRunning
			|| !confirm(
				'Generate the digital Nixie return file for all past TSI imports'
				+ ' and upload it to the SFTP destination?'
			)
		) { return; }
		this.backfillRunning = true;
		this.httpClient.post<SystemMessage>('api/Nixies/Nixies/BackfillDigitalNixie', {}).subscribe({
			next: (msg) => {
				this.backfillRunning = false;
				if (msg?.message) {
					// Show for a minute instead of the default 1.6s; the result can
					// carry per-import warnings that need to be read
					this.ms.setSystemMessage(msg.message, msg.messageClass || 'success', 60000);
				}
			},
			error: () => this.backfillRunning = false,
		});
	}
}
